import {
  Component
} from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
} from 'ionic-angular';
import {
  SignUpProvider
} from '../../providers/sign-up/sign-up';
import {
  ToastProvider
} from '../../providers/toast/toast';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  SignUpOtpPage
} from '../sign-up-otp/sign-up-otp';
import {
  LoginProvider
} from '../../providers/login/login';
import {
  ViewController
} from 'ionic-angular/navigation/view-controller';
import {
  environment
} from '../../environments/environment';
import {
  UtilService
} from '../../services/util';
import {
  TranslateService
} from '@ngx-translate/core';
import { SignUpFormPage } from '../sign-up-form/sign-up-form';


/**
 * Generated class for the SignUpNumberPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
class Port {
  public id: number;
  public name: string;
}
@IonicPage()
@Component({
  selector: 'page-sign-up-number',
  templateUrl: 'sign-up-number.html',
})
export class SignUpNumberPage {
  signUpDetail = {}
  viewData = {}
  aggree = true;
  loader = false
  officeName: any;


  constructor(public navCtrl: NavController,
	public navParams: NavParams,
	private translate: TranslateService,
	private signUpProvider: SignUpProvider,
	private toast: ToastProvider,
	private loginProvider: LoginProvider,
	private viewCtrl: ViewController,
	private util: UtilService
  ) {
	this.officeName = environment.officeName
	this.viewData = {
	  background: '/assets/images/background/26.jpg'
	}
  }

  submitForm(data) {
	if(!this.aggree){
		this.toast.presentToast("You must agree the terms to continue...");
		return false;
	}
	// this.navCtrl.push(SignUpOtpPage,{
	// })
	if (data['name'] == undefined) {
	  this.toast.presentToast("Please Enter Name");
	  return true;
	}
	if (data['phone_no'] == undefined) {
	  this.toast.presentToast("Please Enter Mobile No.");
	  return true;
	}
	if (data.phone_no) {
	  if (data['phone_no'] == !NaN) {
		this.toast.presentToast("Mobile No. will be Numeric Value.");
		return true;
	  } else if (data['phone_no'].length != 10 || data['phone_no'].length > 10) {
		this.toast.presentToast("Mobile No. must be 10 Digit.");
		return true;
	  }
	}
	if (data['email'] == undefined) {
	  this.toast.presentToast("Please enter email");
	  return true;
	}
	this.loader = true
	var dataObj: any = {
	  "name": data.name,
	  "phone_no": data.phone_no,
	  "email": data.email,
	  "app_roles": [],
	  "otp_type": "USER_REGISTRATION"
	}
	this.signUpProvider.generateOtp(dataObj).then(val => {
	  console.log(val)
	  this.loader = false
	  if (val.status == 'success') {
		this.loader = false
		console.log(JSON.stringify(dataObj));
		localStorage.setItem('signup_user_data', JSON.stringify(dataObj));
		this.navCtrl.push(SignUpOtpPage, {
		  otpDetails: val.data
		})
	  } else {
		this.toast.presentToast(val.message);
	  }
	})
  }
  goToLogin() {
	this.viewCtrl.dismiss();
  }
  ionViewDidLoad() {
	console.log('ionViewDidLoad SignUpNumberPage');
  }
  openBaseSpecificUri(url:string){
    this.util.openWithInAppBrowser(environment.baseUrl + url);
  }
}


// WEBPACK FOOTER //
// ./src/pages/sign-up-number/sign-up-number.ts